<template>
  <div class="ts-space-y-4">
    <div class="row">
      <div class="col-md-12">
        <label class="required ts-text-xs">{{ $t('dealerUser.diplayName') }}</label>
        <input type="text" class="form-control" v-model.trim="model.name" />
        <div class="validate ts-text-xs" v-if="errors.has('name')">{{ errors.first('name') }}</div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <ts-checkbox v-model="model.disable">{{ $t('dealerUser.disable') }}</ts-checkbox>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 ts-space-x-3 ts-text-right ts-mt-3">
        <ts-button @click.prevent="$emit('close')">{{ $t('cancel') }}</ts-button>
        <ts-button color="primary" @click.prevent="onUpdate" :waiting="waiting">{{ $t('update') }}</ts-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'frmUpdateUser',
  data() {
    return {
      errors: new Errors(),
      waiting: false,
      model: {
				id: 0,
        name: null,
        disable: false
      }
    }
  },
  computed: {
    ...mapState('administrator/dealerUser', ['edit_data'])
  },
  created() {
    this.model.id = this.edit_data.user_id
    this.model.name = this.edit_data.name
    this.model.disable = this.edit_data.disable
  },
  methods: {
	...mapActions('administrator/dealerUser', ['update']),
  onUpdate() {
      this.errors = new Errors()
      this.waiting = true
      this.update({
        id: this.model.id,
				data: this.model
			})
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('close')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
  }
}
</script>